import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { getIsNotFound } from 'utils/getIsNotFound';
import { getEntitlementsForBusiness } from 'api/admin/businesses/entitlements';
import { ApiError } from 'types/api';
import { StoreEntitlementState } from 'types/entitlements/entitlements';

export const ENTITLEMENTS_FOR_BUSINESS_QUERY_KEY = 'entitlementsForBusiness';

export const useEntitlementsForBusiness = (businessId: number) => {
  return useQuery<StoreEntitlementState[], ApiError>({
    queryKey: [ENTITLEMENTS_FOR_BUSINESS_QUERY_KEY, businessId],
    queryFn: async () => {
      const { data } = await getEntitlementsForBusiness(businessId);

      return data.stores;
    },
    enabled: !!businessId,
    onError: (error) => {
      Sentry.captureException(error);
      // This route answers 404 for a missing business, unlike its 400-answering siblings.
      const message = getIsNotFound(error)
        ? 'Business not found'
        : error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong;

      toast.error(message, { duration: 4000 });
    },
  });
};
